import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.css';

function formatPhoneNumber(phone) {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
  }
  if (cleaned.length === 12) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 8)}-${cleaned.slice(8)}`;
  }
  return phone;
}

const NumberSelector = ({ bots = [], selectedBot = null, onSelect = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => setIsOpen(prev => !prev);

  const handleSelect = (bot, e) => {
    e.stopPropagation();
    onSelect(bot);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const displayText = selectedBot ? formatPhoneNumber(selectedBot.botNumber) : '';

  return (
    <div className={styles.selectorContainer} ref={wrapperRef}>
      <div className={`${styles.selectWrapper}${isOpen ? ` ${styles.active}` : ''}`}>
        <div className={styles.selectedDisplay} onClick={toggleDropdown}>
          <span>{displayText}</span>
          <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
        </div>
        <div className={styles.radioList}>
          {bots.map((bot) => (
            <label
              key={bot.id}
              className={styles.radioItem}
              onClick={e => e.stopPropagation()}
            >
              <input
                type="radio"
                name="bot-number-selector"
                value={bot.id}
                checked={selectedBot?.id === bot.id}
                onChange={(e) => handleSelect(bot, e)}
              />
              <span>{formatPhoneNumber(bot.botNumber)}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NumberSelector;
